import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex gap-4 mt-4" }

import { ref } from "vue";
import { defineEmits, onMounted } from "@vue/runtime-core";
import InputCheckbox from "@/features/shared/components/form/InputCheckbox.vue";
import InputText from "@/features/shared/components/form/InputText.vue";
import * as dtos from "@/models/dtos";
import { useStore } from "vuex";
import InputCheckbox2 from "./InputCheckbox2.vue";
import InputText3 from "./InputText3.vue";
import { DynamicProperty } from "../../models/dtos";
import { FormBuilder2 } from "../../models/FormBuilder2";
import { ToastNotification } from "@/models/ToastNotification";
import InputText2 from "./InputText2.vue";
import BaseInput from "./BaseInput.vue";
import RegularButton from "../ui/RegularButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ElementGroupEditor',
  props: {
    model: {},
    index: {}
  },
  emits: ["change", "remove", "isEdit"],
  setup(__props: any, { emit: __emit }) {

let formIndex = 10000;
const emit = __emit;
const store = useStore();
const form = ref(store.getters.form as FormBuilder2);
const props = __props;
const old = JSON.parse(JSON.stringify(props.model));
const item = ref(props.model as DynamicProperty);

function remove() {
  store.dispatch(
    "addNotification",
    new ToastNotification("success", "Gruppen har tagits bort")
  );
  const form = store.getters.form as FormBuilder2;
  form.removeByProperty(item.value);
  emit("isEdit", false);
}
function removeOption(optionKey: DynamicProperty) {
  form.value.removeOptionFromGroup(item.value.data, optionKey, item.value.key);
}

function addOption() {
  form.value.addOptionToGroup(item.value.data, item.value.key);
}

function onLabelChange(event: any) {
  item.value.label = event;
  item.value.placeholder = event;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", {
      class: "grid grid-cols-4 gap-4",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createVNode(InputText, {
        keyId: "0",
        placeholder: item.value.label,
        label: 
          item.value.type === 'radioGroup'
            ? 'Rubrik för radiogrupp'
            : 'Rubrik för checkboxgrupp'
        ,
        model: item.value.label,
        type: "text",
        onChange: onLabelChange,
        class: "col-span-full"
      }, null, 8, ["placeholder", "label", "model"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.data.keys, (prop, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex col-span-full gap-4 items-center",
          key: i
        }, [
          _createVNode(BaseInput, {
            modelValue: prop.label,
            "onUpdate:modelValue": ($event: any) => ((prop.label) = $event),
            label: 
            item.value.type === 'radioGroup'
              ? `radioknapp ${i + 1}`
              : `checkbox ${i + 1}`
          ,
            placeholder: "Ange texten för checkboxen"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]),
          _createElementVNode("i", {
            onClick: ($event: any) => (removeOption(prop)),
            title: "Ta bort",
            class: "fas fa-trash-alt text-red-2 hover:text-red-2 text-2xl cursor-pointer"
          }, null, 8, _hoisted_1)
        ]))
      }), 128))
    ], 32),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RegularButton, {
        onClick: addOption,
        text: "Lägg till val"
      }),
      _createVNode(RegularButton, {
        onClick: remove,
        "style-type": "cancel",
        text: "Ta bort grupp"
      })
    ])
  ]))
}
}

})